import { RootState } from "redux/store";
import { Link } from "react-router-dom";
import { Title, Modal } from "components";
import { useEffect, useRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getPriceGroups, deletePriceGroups, addAGGridSelectedRows } from "redux/slices/PriceGroups";
import { AgGridReact } from "ag-grid-react";
import { AgGridToolbar } from "components/AgGrid/AgGridToolbar";
import { Z } from "models/common/components";
import { ZTooltip } from "components/ZTooltip";
import { ZIconType } from "helpers/utility/iconMap";
import BaseCellRenderer from "components/AgGrid/CellRenderers/BaseCellRenderer";
import { PriceGroup as PriceGroupInterface} from "models/dbModels/priceGroups/PriceGroup";

export function PriceGroup() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const priceGroups: any = useAppSelector((state: RootState) => state.priceGroups);
    const user = useAppSelector((state: RootState) => state.logedinUser);
    const priceGroupGridRef = useRef<AgGridReact>(null); 
    const [showDelete, setShowDelete] = useState<boolean>(false)

    useEffect(() => {   
        dispatch(getPriceGroups()).then((res) => {
            if(res.totalRows == 0){
                priceGroupGridRef.current?.api.showNoRowsOverlay()
            }
        });
    }, []);

    function handleDelete() {
        let priceGroupIds: number[] | undefined = priceGroupGridRef.current?.api.getSelectedRows().map((x: PriceGroupInterface)=> x.id);
        if(priceGroupIds != undefined && priceGroupIds?.length > 0){
            dispatch(deletePriceGroups(priceGroupIds!)).then(() => {
                dispatch(getPriceGroups());
            });
        }
    }

    return (
        <>
            <Title pageTitle="Price Groups" />
            <Row>
                <Col xs={12}>
                    <Card>
                        <Card.Body>
                            <Row className="mb-1 ps-1 pe-1">
                                <Col xs={12}>                     
                                    <AgGridToolbar
                                        search={true}
                                        className="pb-1"
                                        handleSubmit={(searchState, filterState) => {
                                            priceGroupGridRef.current?.api.clearRangeSelection();
                                            dispatch(addAGGridSelectedRows([]));
                                            priceGroupGridRef.current?.api.setGridOption('quickFilterText', searchState?.keyword);                                            
                                        }}
                                        searchProps={
                                            {totalRows: priceGroups.table.length, placeholder: "by Name", hideContains: true}
                                        }
                                        children={(
                                            <div className="d-inline-flex gap-1">
                                                { 
                                                (priceGroups.selectedRows != undefined && priceGroups.selectedRows != 0) &&									
                                                    <Z.Button variant="light" className="h-100" disabled={true} buttonText={priceGroups.selectedRows.length+ " Selected"}/>
                                                }
                                                 <ZTooltip text="Add">
                                                    <Z.Button icon={ZIconType.Add} buttonSize="md" onClick={() => user.permissions.priceGroups.canCreate ? navigate("/app/price-group/new") : undefined }/>
                                                 </ZTooltip>
                                                <ZTooltip text={
                                                    priceGroups.selectedRows.length == 0? `Please select a row to delete`:
                                                    priceGroups.selectedRows.length == priceGroups.table.length ? `Delete all rows`:									  
                                                    priceGroups.selectedRows.length> 0 ? `Delete ${priceGroups.selectedRows.length} rows` :                                                    
                                                    "Please select a row to delete"}>
                                                    <Z.Button icon={ZIconType.Delete} buttonSize="md"  onClick={() => (user.permissions.priceGroups.canDelete ? setShowDelete(true) : undefined)} 
                                                        disabled={!user.permissions.priceGroups.canDelete || priceGroups.selectedRows.length < 1} />
                                                </ZTooltip>
                                                <ZTooltip text="Refresh">
                                                    <Z.Button icon={ZIconType.Refresh} buttonSize="md" onClick={() => 
                                                        dispatch(getPriceGroups()).then((res) => {
                                                            if(res.totalRows == 0){
                                                                priceGroupGridRef.current?.api.showNoRowsOverlay()
                                                            }
                                                        })} 
                                                        disabled={!user.permissions.priceGroups.canView} />
                                                </ZTooltip>
                                            </div>
                                        )}
                                    />
                                    
                                    <AgGridReact
                                        ref={priceGroupGridRef}
                                        columnDefs={[
                                        {
                                            headerCheckboxSelection: true,
                                            checkboxSelection: true,
                                            width: 45,
                                            sortable: false,
                                            filter: false,
                                            suppressHeaderMenuButton: true,
                                        },    
                                        { 
                                            field: "name",
                                            headerName: "Name",
                                            suppressHeaderMenuButton: true,
                                            flex: 1,
                                            cellRenderer: 'baseCellRenderer',
                                            initialSort: "asc",
                                            cellClass: "aggrid-header-link-lext",
                                            cellRendererSelector: (params) => {
                                                return {                                                   
                                                    component: 'baseCellRenderer',
                                                    params: {
                                                                children: <Link to={`/app/price-group/${params.data.id}`} >{params.data.name}</Link>,
                                                            }
                                                }
                                            }
                                        }]}
                                        rowData={ priceGroups.table }
                                        pagination={true}
                                        paginationPageSize={20}
                                        containerStyle={{ height: "75dvh" }}
                                        className="ag-theme-quartz ag-theme-custom w-100"
                                        rowSelection="multiple"
                                        suppressRowClickSelection={true}
                                        suppressCellFocus={true}                                       
                                        onSelectionChanged={(e) => {
                                            let formatedData:{
                                                positon: number,
                                                id: number
                                            } [] = [];
                                            priceGroupGridRef.current?.api.getSelectedRows().forEach((xe: any) => formatedData.push({ positon: 0, id: xe.id}));
                                            dispatch(addAGGridSelectedRows(formatedData));
                                        }}
                                        onRowSelected={() => {
                                            let formatedData:{
                                                positon: number,
                                                id: number
                                            } [] = [];
                                            priceGroupGridRef.current?.api.getSelectedRows().forEach((xe: any) => formatedData.push({ positon: 0, id: xe.id}));
                                            dispatch(addAGGridSelectedRows(formatedData));
                                        }}
                                        components={{
                                            baseCellRenderer: BaseCellRenderer,
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Modal
                title="Confirm Delete"
                show={showDelete}
                buttonType="primary"
                buttonText={"Continue"}
                buttonCloseText="Cancel"
                handleSubmit={() => {
                    handleDelete();
                    setShowDelete(false);
                    priceGroupGridRef.current?.api.deselectAll();
                    priceGroupGridRef.current?.api.refreshServerSide();
                }}
                handleClose={() => setShowDelete(false)}
                description={
                    <>
                        <p>You are about to delete {priceGroups.selectedRows.length} selected {priceGroups.selectedRows.length > 1 ? "items": "item"}.</p>
                        <p>Are you sure you want to delete?</p>
                    </>
                }
            />
        </>
    );
}